import { render, staticRenderFns } from "./DropTargetFotos.vue?vue&type=template&id=8bec04fc"
import script from "./DropTargetFotos.vue?vue&type=script&lang=js"
export * from "./DropTargetFotos.vue?vue&type=script&lang=js"
import style0 from "./DropTargetFotos.vue?vue&type=style&index=0&id=8bec04fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports